import { useState } from 'react';

export type RightSidebarProps = {
  isRightSidebarOpen: boolean;
  onOpenRightSidebar: () => void;
  onCloseRightSidebar: () => void;
};

const useRightSidebar = (): RightSidebarProps => {
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
  const onOpenRightSidebar = () => {
    setIsRightSidebarOpen(true);
  };

  const onCloseRightSidebar = () => {
    setIsRightSidebarOpen(false);
  };

  return {
    isRightSidebarOpen,
    onOpenRightSidebar,
    onCloseRightSidebar,
  };
};

export default useRightSidebar;
